import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {animateShow} from "../../animations/showHideAnimation";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {filter} from "rxjs/operators";
import {ItemDomService} from "../../services/itemDOMService/item-dom.service";
import {Item} from "../../models/Item";
import {Group} from "../../classes/Groups/Group";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {GroupService} from "../../services/groupService/group-service.service";
import {DomEventsService} from "../../services/dom-event-services/dom-events.service";

@Component({
  selector: 'app-item-additional-block-list',
  templateUrl: './item-additional-block-list.component.html',
  styleUrls: ['./item-additional-block-list.component.scss'],
  animations: [animateShow],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemAdditionalBlockListComponent extends AbstractObserver implements OnInit {
  @ViewChild('element', {static: false}) element;
  public isGroupActionsVisible = false;
  public position = {top: 0, left: 0};
  private delaySubscribe = false;
  isGroupListVisible = false;
  private currentItem:Item = null;
  public Yiit = Yiit;

  constructor(
    private cd: ChangeDetectorRef,
    private itemDom: ItemDomService,
    private gs: GroupService,
    private concreteAdapter: ConcreteLayerService,
    private domService: DomEventsService
    ) {
    super();
  }

  ngOnInit() {
    this.itemDom.isVisible$
      .pipe(filter(val => {return !this.delaySubscribe;}))
      .subscribe((val: boolean) => {
        this.isGroupActionsVisible = val;
        if (!this.isGroupActionsVisible){
          this.currentItem = null;
          this.domService.currentActiveAdditionalMenuElement = null;
        }
        this.cd.detectChanges();
        this.domService.currentActiveAdditionalMenuElement = this.element;
        this.cd.detectChanges();
      });

    this.subscribeToObservable(this.itemDom.activeItem$, (item)=>{
      if (this.isGroupActionsVisible){
        this.isGroupActionsVisible = false;
        this.delaySubscribe = true;
        this.cd.detectChanges();
        setTimeout(()=>{
          this.delaySubscribe = false;
          this.isGroupActionsVisible = true;
          this.setNewItem(item);
        }, 300)
      }
      else{
        this.setNewItem(item);
      }
    });
  }

  setGroupListVisibility(val: boolean){
    this.isGroupListVisible = val;
  }

  private setNewItem(item){
    this.currentItem = item;
    this.position = this.itemDom.position;
    this.cd.detectChanges();
  }

  removeObject(){
    if (confirm(this.Yiit.t('Are you sure?'))) {
      this.currentItem.removeObject();
      this.currentItem = null;
      if (this.isGroupActionsVisible) {
        this.domService.currentActiveAdditionalMenuElement = null;
      }
      this.isGroupActionsVisible = false;
    }
  }

  moveToGroup(group:Group){
    this.gs.moveToNewGroup(this.currentItem, group);
    this.isGroupListVisible = false;
    if (this.isGroupActionsVisible){
      this.domService.currentActiveAdditionalMenuElement = null;
    }
    this.isGroupActionsVisible = false;
    this.itemDom.isVisible$ = false;
    this.cd.detectChanges()
  }

  getAllGroupsExceptCurrent(){
    let gList = this.gs.groupList.slice(0);
    let currentGroup = this.gs.getGroupById(this.currentItem.config.getGroupId());
    gList.splice(gList.indexOf(currentGroup), 1);
    gList = gList.filter((group)=>{
      return group.getFloorPlanId() == this.concreteAdapter.selectedConcrete.id && !group.is_empty;
    });

    let gListCopy = gList.slice();
    let resultGroupsObject:{[key: string]: Group[]} = {};

    let parentGroups:Group[] = gListCopy.filter((g)=>{
      return !g.getParentGroupId();
    }).sort((a,b )=>{
      return a.getTitle().toString().toLowerCase() < b.getTitle().toString().toLowerCase() ? -1 : 1;
    });

    parentGroups.forEach((g)=>{
      if (!resultGroupsObject.hasOwnProperty(g.getId())){
        resultGroupsObject[g.getId()] = [];
      }
    });

    gListCopy.filter((g)=>{
      return g.getParentGroupId();
    }).forEach((_g)=>{
      if (resultGroupsObject.hasOwnProperty(_g.getParentGroupId())){
        resultGroupsObject[_g.getParentGroupId()].push(_g);
      }
    });

    let indexAdditional = 0;
    parentGroups.slice().forEach((_parent,index)=>{
      if (resultGroupsObject.hasOwnProperty(_parent.getId()) && resultGroupsObject[_parent.getId()].length > 0){
        parentGroups.splice( index+1+indexAdditional, 0, ...resultGroupsObject[_parent.getId()]);
        indexAdditional+=resultGroupsObject[_parent.getId()].length;
      }
    });
    return parentGroups;
    // return [].concat(parentGroups, childGroups).sort(this.sortGroups);
  }

  /**
   * -1 = up
   * 1 = down
   * @param a - next = objects
   * @param b - prev = assets
   */
  // private sortGroups(a,b){
  //     if(!a.getParentGroupId() && !b.getParentGroupId()){
  //       console.log('1', a,b);
  //       return a.getTitle().toString().toLowerCase() < b.getTitle().toString().toLowerCase() ? -1 : 1;
  //     }
  //     if (!a.getParentGroupId() && b.getParentGroupId()){
  //       console.log('2', a,b);
  //       if (a.getId() == b.getParentGroupId()){
  //         return 0;
  //       }
  //         return 1;
  //     }
  //     if (a.getParentGroupId() && !b.getParentGroupId()){
  //       console.log('3', a,b);
  //       if (a.getParentGroupId() == b.getId()){
  //         return 0;
  //       }
  //       return -1;
  //     }
  //     console.log('4', a,b);
  //     if (a.getParentGroupId() && b.getParentGroupId()){
  //       if (a.getParentGroupId() == b.getParentGroupId){
  //         if (a.getId() < b.getId()){
  //           return -1
  //         }
  //         return 0;
  //       }
  //
  //     }
  //     return 0;
  // }

  hasAnotherGroup(){
    return this.getAllGroupsExceptCurrent().length > 0;
  }

}
